import { GeoNode, GeoNodeLevel } from '@app/models/dictionaries';

import { ATTR_META } from '../data/constants';
import { RuleAttribute } from '../interfaces';

/** Известный ли это атрибут (из нашего словаря). */
export const isKnownAttribute = (attr: string): attr is RuleAttribute =>
  Object.prototype.hasOwnProperty.call(ATTR_META, attr);

export const geoNodeLabel = (node: GeoNode): string =>
  node.level === GeoNodeLevel.Region ? node.name : `${node.name} (${node.region_name})`;
